// import React, { useState, useEffect, useRef } from "react";
// import { assets } from "../../../assets/assets";
// import "./style/caseUnit.css";
// import { useZone } from "../../../context/ZoneContext";
// import { useTabsFilter } from "../../../context/TabsFilterContext";

// // function CaseUnit({ isTransparent, onSelectionChange }) {
//   // const { availability } = useZone();
//   function CaseUnit({ isTransparent, onSelectionChange, lang }) {
//   const { availability } = useZone({ lang });
//   const dropdownRef = useRef(null);
//   const allItems = availability || [];

//   const { availabilitySelection, onFilterChange } = useTabsFilter();

//   const [selectedItems, setSelectedItems] = useState(allItems);

//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   useEffect(() => {
//     if (availabilitySelection.length === 0 && allItems.length > 0) {
//       setSelectedItems(allItems);
//     } else {
//       const mapped = allItems.filter((item) =>
//         availabilitySelection.includes(item.id)
//       );
//       setSelectedItems(mapped);
//     }
//   }, [availabilitySelection, allItems]);

// // const handleItemClick = (item) => {
// //   let newSelection;

// //   if (availabilitySelection.includes(item.id)) {
// //     // إزالة العنصر
// //     newSelection = availabilitySelection.filter((id) => id !== item.id);
// //   } else {
// //     // إضافة العنصر
// //     newSelection = [...availabilitySelection, item.id];
// //   }

// //   onFilterChange("availability", newSelection);

// //   // لو فيه onSelectionChange خارجي
// //   if (onSelectionChange) onSelectionChange(newSelection);
// // };
// const handleItemClick = (item) => {
//   let newSelection;

//   if (availabilitySelection.includes(item.id)) {
//     newSelection = availabilitySelection.filter((id) => id !== item.id);
//   } else {
//     newSelection = [...availabilitySelection, item.id];
//   }

//   // 🔹 السلوك الأساسي (SVG)
//   onFilterChange("availability", newSelection);

//   // 🔹 سلوك إضافي (SearchFilter فقط)
//   if (onSelectionChange) {
//     onSelectionChange(newSelection);
//   }
// };

//   const isCancelled = (item) => availabilitySelection.includes(item.id);

//   const getButtonText = () => {
//   // المتفعّل = الكل - الملغي
//   const activeItems = allItems.filter(
//     (item) => !availabilitySelection.includes(item.id)
//   );

//   // كله متفعّل
//   if (activeItems.length === allItems.length) {
//     return "View All";
//   }

//   // ولا واحد متفعّل
//   if (activeItems.length === 0) {
//     return "None";
//   }

//   const activeNames = activeItems.map((item) => item.name).join(", ");

//   return activeNames.length > 35
//     ? `${activeNames.slice(0, 35)}...`
//     : activeNames;
// };

//   // اغلاق الدروبداون عند الكليك برا
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <>
//       <div className="dropdown type-unit col-12" ref={dropdownRef}>
//         <p className="p-0 w-100 property-type">Availability</p>
//         <button
//           className={`btn btn-view-all dropdown-toggle col-12 `}
//           type="button"
//           onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//           aria-expanded={isDropdownOpen}
//         >
//           {getButtonText()}
//           <img
//             src={assets.arrowDropdownWhite}
//             alt="Filter Icon"
//             className="filter-icon arrow-icon"
//           />
//         </button>
//         {isDropdownOpen && (
//           <div
//             className="dropdown-menu col-12 show"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {allItems.length === 0 ? (
//               <p className="dropdown-item empty-state">لا يوجد عناصر</p>
//             ) : (
//               allItems.map((item) => (
//                 <p
//                   key={item.id}
//                   className={`dropdown-item ${
//                     isCancelled(item) ? "not-selected-item" : "selected-item"
//                   }`}
//                   style={{
//                     backgroundColor: isCancelled(item) ? "#fff" : item.color,
//                     color: isCancelled(item) ? "#000" : "#fff",
//                   }}
//                   onClick={() => handleItemClick(item)}
//                 >
//                   {item.name}
//                 </p>
//               ))
//             )}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// export default CaseUnit;



















import React, { useRef } from "react";
import { assets } from "../../../assets/assets";
import "./style/caseUnit.css";
import { useZone } from "../../../context/ZoneContext";
import { useTabsFilter } from "../../../context/TabsFilterContext";

function CaseUnit({ isTransparent, onSelectionChange, lang, isOpen, toggleOpen }) {
  const { availability } = useZone({ lang });
  const dropdownRef = useRef(null);
  const allItems = availability || [];
  const { availabilitySelection, onFilterChange } = useTabsFilter();

  const handleItemClick = (item) => {
    let newSelection = availabilitySelection.includes(item.id)
      ? availabilitySelection.filter((id) => id !== item.id)
      : [...availabilitySelection, item.id];

    onFilterChange("availability", newSelection);
    if (onSelectionChange) onSelectionChange(newSelection);
  };

  const isCancelled = (item) => availabilitySelection.includes(item.id);

  const getButtonText = () => {
    const activeItems = allItems.filter(item => !availabilitySelection.includes(item.id));
    if (activeItems.length === allItems.length) return "View All";
    if (activeItems.length === 0) return "None";
    const activeNames = activeItems.map((item) => item.name).join(", ");
    return activeNames.length > 35 ? `${activeNames.slice(0, 35)}...` : activeNames;
  };

  return (
    <div className="dropdown type-unit col-12" ref={dropdownRef}>
      <p className="p-0 w-100 property-type">Availability</p>
      <button
        className="btn btn-view-all dropdown-toggle col-12"
        type="button"
        onClick={toggleOpen}
        aria-expanded={isOpen}
      >
        {getButtonText()}
        <img src={assets.arrowDropdownWhite} alt="icon" className={`filter-icon arrow-icon ${isOpen ? "open" : ""}`} />
      </button>
      {isOpen && (
        <div className="dropdown-menu col-12 show" onClick={(e) => e.stopPropagation()}>
          {allItems.length === 0 ? (
            <p className="dropdown-item empty-state">لا يوجد عناصر</p>
          ) : (
            allItems.map((item) => (
              <p
                key={item.id}
                className={`dropdown-item ${isCancelled(item) ? "not-selected-item" : "selected-item"}`}
                style={{ backgroundColor: isCancelled(item) ? "#fff" : item.color, color: isCancelled(item) ? "#000" : "#fff" }}
                onClick={() => handleItemClick(item)}
              >
                {item.name}
              </p>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default CaseUnit;